:root {
  /* Refined brand — same identity, contemporary execution */
  --color-bg: #f4f6f9;
  --color-bg-elevated: #ffffff;
  --color-surface: #ffffff;
  --color-surface-alt: #eef1f6;
  --color-text: #0f1419;
  --color-muted: #5c6670;
  --color-muted-soft: #8b959f;
  --color-primary: #dc2f27;
  --color-primary-bright: #e9423a;
  --color-primary-dark: #b91c1c;
  --color-navy: #252b47;
  --color-purple: #5c2d84;
  --color-accent: #f0b429;
  --color-border: rgba(15, 20, 25, 0.08);
  --color-border-strong: rgba(15, 20, 25, 0.12);
  --color-dark: #0d0f14;
  --color-dark-elevated: #161922;

  --gradient-brand: linear-gradient(
    135deg,
    #e9423a 0%,
    #7c3aed 52%,
    #312e81 100%
  );
  --gradient-brand-soft: linear-gradient(
    160deg,
    rgba(233, 66, 58, 0.06) 0%,
    rgba(124, 58, 237, 0.05) 45%,
    rgba(49, 46, 129, 0.07) 100%
  );
  --gradient-mesh: radial-gradient(
      ellipse 120% 80% at 100% -20%,
      rgba(124, 58, 237, 0.09),
      transparent 50%
    ),
    radial-gradient(
      ellipse 90% 70% at -10% 60%,
      rgba(233, 66, 58, 0.07),
      transparent 45%
    );

  --font-display: 'Playfair Display', Georgia, serif;
  --font-body: 'Poppins', system-ui, sans-serif;

  --radius-sm: 10px;
  --radius-md: 14px;
  --radius-lg: 20px;
  --radius-xl: 28px;
  --radius-full: 9999px;

  --shadow-xs: 0 1px 2px rgba(15, 20, 25, 0.04);
  --shadow-sm: 0 1px 2px rgba(15, 20, 25, 0.04),
    0 8px 24px rgba(15, 20, 25, 0.06);
  --shadow-md: 0 4px 8px rgba(15, 20, 25, 0.04),
    0 20px 40px rgba(15, 20, 25, 0.08);
  --shadow-glow: 0 0 0 1px rgba(255, 255, 255, 0.08) inset;
  --shadow-primary: 0 8px 24px rgba(233, 66, 58, 0.22);

  --ease-out: cubic-bezier(0.22, 1, 0.36, 1);
  --header-h: 72px;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  font-family: var(--font-body);
  font-size: 16px;
  line-height: 1.55;
  letter-spacing: -0.01em;
  background-color: var(--color-bg);
  background-image: var(--gradient-mesh);
  background-attachment: fixed;
  color: var(--color-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,
h2,
h3 {
  font-family: var(--font-display);
  letter-spacing: -0.03em;
}

#root {
  min-height: 100vh;
}

a {
  color: inherit;
}

::selection {
  background: rgba(233, 66, 58, 0.2);
  color: var(--color-text);
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
